const API_BASE = 'https://ncht.bz/api/agent';

function authHeaders() {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  if (!token) {
    throw new Error('Токен авторизации не найден');
  }
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

export async function sendAgentChat(chatInput, sessionId, signal) {
  const response = await fetch(`${API_BASE}/chat`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ chatInput, sessionId }),
    signal,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`HTTP ${response.status}${text ? ': ' + text.slice(0, 200) : ''}`);
  }

  return response.json();
}
